export enum caseTypeEnum {
  SIGNIN = "1001",
  CHAT = "1003",
  PROMISE = "1002",
  CALL = "1004",
  SECURITY_EMERGENCY = "1005",
}
